export default __webpack_public_path__ + "static/media/BANNER CIC.2984a8b3.png";